import { createAsyncThunk } from '@reduxjs/toolkit';
import { feathersClient } from '../../../client/index';
import { toastHandler } from '../../../utils/toastHandler';

export interface CakeEditLog {
  id: string;
  orderCakeId: string;
  orderId: string;
  orderItemId: string;
  updatedBy: string;
  oldPrice: number | string | null;
  newPrice: number | string | null;
  priceDifference: number | string | null;
  priceChangeType: 'increase' | 'decrease' | 'no_change';
  oldData: any;
  newData: any;
  changes: any;
  updatedAt: string;
  // Stored names for efficient display
  shapeName?: string;
  flavorName?: string;
  toppingName?: string;
  userFullName?: string;
  userName?: string;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  order_cake?: {
    id: string;
    shapeId: string;
    flavorId: string;
    toppingId: string;
    shape?: {
      id: string;
      labelEn: string;
      labelAr: string;
    };
    flavor?: {
      id: string;
      labelEn: string;
      labelAr: string;
    };
    topping_category_item?: {
      id: string;
      labelEn: string;
      labelAr: string;
    };
  };
}

export interface CakeEditLogsResponse {
  success: boolean;
  data: CakeEditLog[];
  count: number;
}

export const getCakeEditLogsByOrderId = createAsyncThunk(
  'cakeEditLogs/getCakeEditLogsByOrderId',
  async (orderId: string, { rejectWithValue }) => {
    try {
      console.log('Fetching cake edit logs for order:', orderId);
      
      const cakeEditLogService = feathersClient.service('cake-edit-log');
      const response = await cakeEditLogService.find({
        query: {
          orderId: orderId,
          $sort: { updatedAt: -1 }
        }
      });

      console.log('Cake edit logs response:', response);
      
      return {
        success: true,
        data: response.data || response,
        count: response.total || (response.data ? response.data.length : 0)
      } as CakeEditLogsResponse;
    } catch (error: any) {
      console.error('Error fetching cake edit logs:', error);
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
